import { AuthorizedRoute } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import { withRouter } from 'Lib/hoc';
import { Navigate, Route, Routes } from 'react-router';
import BiobankDetailsPage from './BiobankDetailsPage';
import BiobankListView from './BiobankListView';

let BiobankDetailWithRouter = withRouter(BiobankDetailsPage);

const Biobanks = () => {
  return (
    <Routes>
      <Route path='' element={<Navigate to='all' replace />} />
      <Route
        path='all'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.BIOBANK_LANDING.requiredAuth}>
            <BiobankListView />
          </AuthorizedRoute>
        }
      />
      <Route
        path='all/:id'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.BIOBANK_LANDING.requiredAuth}>
            <BiobankDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Biobanks);
export default Page;
